import {CommonMessages} from '../common.messages';

export const PanelSettingsOperatorsAddMessages = {
    GetRolesFailed: {
        key: 'GetRolesFailed',
        message: 'Error while communication with the server. Unable to get roles needed for operator creation.'
    },
    RolesNotFound: {
        key: 'RolesNotFound',
        message: 'Error while communication with the server. No roles for operator creation.'
    },
    OperatorCreationFailed: {
        key: 'OperatorCreationFailed',
        message: 'Error while processing request. Unable to create an operator.'
    },
    AssignUserRoleFailed: {
        key: 'AssignRoleFailed',
        message: 'Error while processing request. Unable to assign role to the operator.'
    },
    OperatorCreationSucceed: {
        key: 'OperatorCreationSucceed',
        message: 'Operator is successfully created.'
    },
    GetUserFailed: {
        key: 'GetUserFailed',
        message: 'Error while processing request to the server. Can match user operator criteria.'
    },
    UserExists: {
        key: 'UserExists',
        message: 'A user with this email already exists.'
    },
    UserConfirmationEmailSendFailed: {
        key: 'UserConfirmationEmailSendFailed',
        message: 'Error while processing request to the server. Unable to send confirmation email to the operator.'
    },
    ...CommonMessages
};
